<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý khách hàng</div>
      </div>
      <div class="card card-w-title" v-if="$myConstants.checkRoleGroup('customer', 'history')">
        <div class="box-top-list">
          <span class="p-m-0">Lịch sử cập nhật thông tin khách hàng</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
          </span>
        </div>
        <div class="list-data">
          <div class="list-title">
            <span class="p-m-0">Danh sách lịch sử cập nhật</span>
          </div>
          <BaseCommon v-if="dataModel"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :isFilter="false"
            @callback="callback"
          ></BaseCommon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      listData: [],
      dataModel: null,
      componentKey: 0,
      modelName: 'customer_log_changed'
    }
  },
  async mounted () {
    this.dataModel = DataServices.getModel(this.modelName);
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      await this.getData(Number(this.$route.params.id));
    }
  },
  methods: {
    callback(col, payload) {
      this.$router.push({path: '/admin/customer/history-detail/' + payload.id });
    },
    async getData(id) {
      var variables = {
        where_key: {
          customer_profile_id: {'_eq': id }
        },
        orderBy: {
          id: 'desc',
          modified_date: 'desc',
          created_date: 'desc'
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData(list);
      this.listData = list;
      this.componentKey++;
    },
    backList() {
      this.$router.push({path: '/admin/customer'});
    }
  }
}
</script>
<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.box-top-list{ margin-bottom: 30px;
  span{font-size: 20; text-align: left; }
  .right-button{float: right;}
}
.external-link{ color: #0066FF; cursor: pointer;}
</style>